module.exports = __webpack_public_path__ + "img/rows-02.93fa6443.svg";